define('boxes/helpers/signUpValidation',['jquery', 'boxes/helpers/tooltip', 'all/jquery/jquery.validate'], function ($, toolTip) {
	'use strict';

	var DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-dynamic-error',
		INFO_MESSAGE_DATA_ATTRIBUTE = 'content-info',
		ERROR_CLASS = 'has-error',
		VALID_CLASS = 'is-valid',
		SIGNUP_DETAILS_ID = '#signup-details',
		$autoFill, $signUpDetails, $signUpAccount, landingSignUp, $birthDate, $year, $month, $day, $gender,
		$gamblingRange,
		currentYear = new Date().getFullYear(),
		currentMonth = new Date().getMonth() + 1,
		currentDay = new Date().getDate(),
		MIN_LENGTH_USERNAME = 5,
		MAX_LENGTH_USERNAME = 16,
		MIN_LENGTH_EMAIL = 5,
		MAX_LENGTH_EMAIL = 50,
		FIRST_STEP_USERNAME = '#signup-username',
		SECOND_STEP_USERNAME = '#signup-username-edit',
		FIRST_STEP_PASSWORD = '#signup-password',
		SECOND_STEP_PASSWORD = '#signup-password-edit',
		LANDING_SIGNUP = '.cnt-overlay.signup';

	function checkUnique(data, element, flow) {
		var $input = $(element),
			$inputParent = $input.parent(),
			response = true;

		if (validateUsernameEmailContent($input)) {
			$.ajax({
				async: true,
				type: 'GET',
				url: '/pp?flow=' + flow,
				data: data,
				dataType: 'json',
				success: function (data) {
					response = data.RESULT === 'OK';
					if (response === true) {
						$inputParent.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
						// $inputParent.find('.popover').hide();
						$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
					} else {
						$inputParent.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.ERROR);
						$inputParent.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
						// toolTip.showError($inputParent);
					}
					hideLoadingGif($inputParent);
					updateInputWithGreenTick($input);
				}
			});
			showLoadingGif($inputParent);
		} else {
			handleInCorrectlyFilledUsrEmail($input);
		}
		return response;
	}

	function handleInCorrectlyFilledUsrEmail($input) {
		var $inputParent = $input.parent();
		$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
		$inputParent.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
		// toolTip.showError($inputParent);
		updateInputWithGreenTick($input);
	}

	function checkUniqueUsername(value, element) {
		return checkUnique({ PARAM_USER_NAME: value }, element, 'CheckUsername');
	}

	function checkUniqueEmail(value, element) {
		return checkUnique({ PARAM_EMAIL: value }, element, 'CheckEmail');
	}

	function checkDifferFrom(value, element, params) {
		return value.valueOf() !== $(params).val().valueOf();
	}

	function genderSelected() {
		var $activeButton = $gender.find('.btn.active'),
			isValid = $activeButton.length !== 0;
		if (isValid) {
			$gender.find('.has-error').removeClass(ERROR_CLASS);
		} else {
			$gender.on('click', function () {
				$gender.css('color', 'black');
			});
			$gender.css('color', '#C00000');
		}
		return isValid;
	}

	function highlight(element, errorClass, validClass) {
		var $input = $(element),
			$inputParent = $input.parent();
		if ($inputParent.data('async')) {
			return;
		}
		$inputParent.addClass(errorClass).removeClass(validClass);
		// handlePasswordGreenTick();
	}

	function unhighlight(element, errorClass, validClass) {
		var $input = $(element),
			$inputParent = $input.parent();
		if ($inputParent.data('async')) {
			return;
		}
		$inputParent.removeClass(errorClass).addClass(validClass);
		$inputParent.popover('destroy');
		// handlePasswordGreenTick();
	}

	function hideGreenTick($input) {
		$input.prev().hide();
	}

	function showGreenTick($input) {
		$input.prev().show();
	}

	function errorPlacement(error, element) {
		$('.popover').hide();
		toolTip.showError($(element).parent(), $(error).text());
	}

	function selectCheck(value) {
		return (value !== '0');
	}

	function addValidationCustomRules() {
		$.validator.addMethod('uniqueUsername', checkUniqueUsername);
		$.validator.addMethod('genderSelected', genderSelected);
		$.validator.addMethod('uniqueEmail', checkUniqueEmail);
		$.validator.addMethod('differFrom', checkDifferFrom);
		$.validator.addMethod('selectCheck', selectCheck);
		$.validator.addMethod('onlyLettersSpacesDashesAllowed', isOnlyLettersSpacesDashes);
		$.validator.addMethod('notOnlyLetters', notOnlyLetters);
		$.validator.addMethod('customEmailValidation', customEmailValidation);
	}

	function setupFormValidation() {
		addValidationCustomRules();
		var accountFormRules = {
				PARAM_USR_NAME: {
					required: true,
					uniqueUsername: true
				},
				PARAM_EMAIL: {
					required: true,
					uniqueEmail: true
				},
				PARAM_PASSWORD: {
					required: true,
					notOnlyLetters: true,
					minlength: 6,
					maxlength: 15,
					differFrom: function () {
						return differFromUsername();
					}
				},
				repeatPassword: {
					required: true,
					notOnlyLetters: true,
					minlength: 6,
					maxlength: 15,
					equalTo: function () {
						return equalToPassword();
					},
					differFrom: function () {
						return differFromUsername();
					}
				}
			},

			detailsFormRules = {
				PARAM_FIRST_NAME: {
					required: true,
					onlyLettersSpacesDashesAllowed: true,
					minlength: 2,
					maxlength: 20
				},
				PARAM_SURNAME: {
					required: true,
					onlyLettersSpacesDashesAllowed: true,
					minlength: 2,
					maxlength: 20
				},
				PARAM_ADDRESS1: {
					required: true,
					minlength: 2,
					maxlength: 50
				},
				PARAM_POST_CODE: {
					required: true,
					minlength: 2,
					maxlength: 20
				},
				PARAM_CITY: {
					required: true,
					onlyLettersSpacesDashesAllowed: true,
					minlength: 2,
					maxlength: 30
				},
				PARAM_GENDER_MALE: {
					genderSelected: true
				},
				PARAM_GENDER_FEMALE: {
					genderSelected: true
				}
			},
			setupValidation = {
				errorClass: ERROR_CLASS,
				validClass: VALID_CLASS,
				ignore: '.ignore',
				highlight: highlight,
				unhighlight: unhighlight,
				errorPlacement: errorPlacement,
				onkeyup: false
			},
			setupValidationStepOne = $.extend({}, setupValidation, { rules: accountFormRules }),
			setupValidationStepTwo = $.extend({}, setupValidation, { rules: detailsFormRules });

		if ($gamblingRange) {
			detailsFormRules['PARAM_CPR'] = {
				required: true,
				minlength: 4,
				maxlength: 4,
				digits: true,
				range: [0, 9999]
			};
		}

		$signUpAccount.validate(setupValidationStepOne);
		$signUpDetails.validate(setupValidationStepTwo);
	}

	function allowedAgeToPlay(countryIsoCode) {
		if (countryIsoCode === 'ee') {
			return 21;
		} else {
			return 18;
		}
	}

	function maxYearAllowed(countryIsoCode) {
		var allowedAge = allowedAgeToPlay(countryIsoCode);
		return currentYear - allowedAge;
	}

	function maxMonthAllowed(yearSelected, countryIsoCode) {
		var allowedAge = allowedAgeToPlay(countryIsoCode);
		if (yearSelected === currentYear - allowedAge) {
			$signUpDetails.find('select[name=PARAM_DAY]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			$signUpDetails.find('select[name=PARAM_MONTH]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			$signUpDetails.find('select[name=PARAM_YEAR]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			return currentMonth;
		} else {
			return 12;
		}
	}

	function maxDayAllowed(monthSelected, yearSelected, countryIsoCode) {
		if (countryIsoCode === 'ee') {
			if ((yearSelected === currentYear - 21) && monthSelected === currentMonth) {
				return currentDay;
			} else {
				return 31;
			}
		} else {
			if ((yearSelected === currentYear - 18) && monthSelected === currentMonth) {
				return currentDay;
			} else {
				return 31;
			}
		}
	}

	function onFocusOutDateOfBirth() {
		$birthDate.find('select').change(function () {
			var yearSelected = Number($signUpDetails.find('select[name=PARAM_YEAR] option:selected').text()),
				monthSelected = Number($signUpDetails.find('select[name=PARAM_MONTH] option:selected').text()),
				daySelected = Number($signUpDetails.find('select[name=PARAM_DAY] option:selected').text()),
				countryIsoCode = $autoFill.data('country-iso-code').toLowerCase();
			if (countryIsoCode === '' || countryIsoCode === '**') {
				countryIsoCode = 'se';
			}
			if (!isNaN(yearSelected) && !isNaN(monthSelected) && !isNaN(daySelected)) {
				if (yearSelected > maxYearAllowed(countryIsoCode)) {
					highLightYear();
				} else if (monthSelected > maxMonthAllowed(yearSelected, countryIsoCode)) {
					highLightMonth();
				} else if (daySelected > maxDayAllowed(monthSelected, yearSelected, countryIsoCode)) {
					highLightDay();
				} else if ((monthSelected === 4 || monthSelected === 6 || monthSelected === 9 || monthSelected === 11) && daySelected === 31) {
					highLightDay();
				} else if (monthSelected === 2) {
					var isLeap = (yearSelected % 4 === 0 && (yearSelected % 100 !== 0 || yearSelected % 400 === 0));
					if (daySelected > 29 || (daySelected === 29 && !isLeap)) {
						highLightDay();
					} else {
						unHighLightYearMonthDay();
					}
				}
				else {
					unHighLightYearMonthDay();
				}
			} else {
				unHighLightYearMonthDay();
			}
		});
	}

	function validateDanishGamblingRange() {
		if ($gamblingRange) {
			if ($signUpDetails.find('select[name=gamblingRangeSelect] option:selected').length > 0) {
				var gamblingRangeId = Number($signUpDetails.find('select[name=gamblingRangeSelect] option:selected')[0].value);
				if (gamblingRangeId === 0) {
					highlightGamblingRange();
				} else {
					unhighlightGamblingRange();
				}
			}
		}
	}

	function highLightYear() {
		$year.parent().removeClass(VALID_CLASS).addClass(ERROR_CLASS);
	}

	function highLightMonth() {
		$month.parent().removeClass(VALID_CLASS).addClass(ERROR_CLASS);
	}

	function highLightDay() {
		$day.parent().removeClass(VALID_CLASS).addClass(ERROR_CLASS);
	}

	function unHighLightYearMonthDay() {
		$day.parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$year.parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$month.parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
	}

	function highlightGamblingRange() {
		$gamblingRange.parent().removeClass(VALID_CLASS).addClass(ERROR_CLASS);
	}

	function unhighlightGamblingRange() {
		$gamblingRange.parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
	}

	function validateDateTheFirstTime() {
		var yearSelected = Number($signUpDetails.find('select[name=PARAM_YEAR] option:selected').text()),
			monthSelected = Number($signUpDetails.find('select[name=PARAM_MONTH] option:selected').text()),
			daySelected = Number($signUpDetails.find('select[name=PARAM_DAY] option:selected').text());
		if (isNaN(yearSelected)) {
			highLightYear();
		}
		if (isNaN(monthSelected)) {
			highLightMonth();
		}
		if (isNaN(daySelected)) {
			highLightDay();
		}
	}

	function updateInputWithGreenTick($element) {
		if ($element.parent().hasClass(ERROR_CLASS)) {
			hideGreenTick($element);
		} else if ($element.parent().hasClass(VALID_CLASS)) {
			showGreenTick($element);
		}
	}

	function handlePasswordGreenTick() {
		var $inputFields = $signUpAccount.find('input[name=PARAM_PASSWORD], input[name=repeatPassword]');
		$inputFields.each(function () {
			if ($(this).parent().hasClass(ERROR_CLASS)) {
				$(this).prev().hide();
			} else {
				if ($(this).val() !== '') {
					$(this).prev().show();
				} else {
					$(this).prev().hide();
				}
			}
		});
	}

	function removeGreenTickWhenContentEmpty() {
		var $inputFields = $('input');
		$inputFields.each(function () {
			$(this).focusout(function () {
				if ($(this).val() === '') {
					hideGreenTick($(this));
				}
			});
		});
	}

	function customEmailValidation(value) {
		return /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/.test(value);
	}

	function isOnlyLettersSpacesDashes(value) {
		var valid = true;
		for (var i = 0, x = value.length; i < x; i++) {
			if ((value.charCodeAt(i) >= 0 && value.charCodeAt(i) < 32) || (value.charCodeAt(i) > 32 && value.charCodeAt(i) < 44) ||
				(value.charCodeAt(i) > 45 && value.charCodeAt(i) < 65) || (value.charCodeAt(i) > 90 && value.charCodeAt(i) < 97) ||
				(value.charCodeAt(i) > 122 && value.charCodeAt(i) < 128)) {
				valid = false;
			}
		}
		return valid;
	}

	function isOnlyNumbersAndLetters(value) {
		return /^[a-zA-Z\d]+$/.test(value);
	}

	function notOnlyLetters(value) {
		var valid = true,
			hasAsciiLetter = false,
			hasNumber = false;
		for (var i = 0, x = value.length; i < x; i++) {
			var code = value.charCodeAt(i);
			if (code < 33 || code > 126) {
				valid = false;
				break;
			} else if (!hasAsciiLetter && ((code < 91 && code > 64) || (code < 123 && code > 96))) {
				hasAsciiLetter = true;
			} else if (!hasNumber && code > 47 && code < 58) {
				hasNumber = true;
			}
		}
		if (!hasAsciiLetter) {
			valid = false;
		}
		if (valid && !hasNumber) {
			valid = false;
		}
		return valid;
	}


	function setupFocusPopover(signUpAccount) {
		signUpAccount.$box.parent().find('input, select').focus(function () {
			$('.popover').hide();
			//$('.popover').each(function(){
			//	if($(this).parent().hasClass(VALID_CLASS)){
			//		$(this).hide();
			//	}
			//});
			var $inputParentElement = $(this).parent(),
				isMonthDayFocused = false;

			if ($(this).attr('name') === 'PARAM_MONTH' || $(this).attr('name') === 'PARAM_DAY') {
				isMonthDayFocused = true;
			}

			if ($inputParentElement.hasClass(ERROR_CLASS) && isMonthDayFocused) {
				toolTip.showError($year.parent());
			} else if ($inputParentElement.hasClass(ERROR_CLASS)) {
				toolTip.showError($inputParentElement);
			}
			else {
				toolTip.showPopover($inputParentElement, $inputParentElement.data(INFO_MESSAGE_DATA_ATTRIBUTE));
			}
		});
	}

	function hideLoadingGif($parentInput) {
		$parentInput.find('img').hide();
	}

	function showLoadingGif($parentInput) {
		$parentInput.find('img').show();
	}

	function isFormValidated($form) {
		$form.valid();
		handlePasswordGreenTick();
		highLightEmptyUsernameEmail($form);
		return $form.find('.' + ERROR_CLASS).not(':has(#signup-autofill)').length === 0;
	}

	function fillCPRFormattedCode($signUpForm) {
		// Fill CPR field with right format for danish personal number
		$signUpForm.find('input[name=PARAM_FORMATTED_CPR]').val(
			('0' + $($signUpForm).find('#birth-date-id select')[2].value).slice(-2) + // gets 2 digits from day field
			('0' + $($signUpForm).find('#birth-date-id select')[1].value).slice(-2) + // gets 2 digits from month field
			$($signUpForm).find('#birth-date-id select')[0].value.slice(-2) + // gets last 2 digits from year field
			$signUpForm.find('input[name=PARAM_CPR]').val()
		);
	}

	function highLightEmptyUsernameEmail($form) {
		$form.find('input[name=PARAM_USR_NAME],input[name=PARAM_EMAIL]').each(function () {
			if ($(this).val() === '') {
				$(this).parent().addClass(ERROR_CLASS).removeClass(VALID_CLASS);
			}
		});
	}

	function validateUsernameEmailContent($input) {
		if ($input.val() === '') {
			return false;
		} else if ($input.attr('name') === 'PARAM_USR_NAME') {
			return checkUsernameLength($input) && isOnlyNumbersAndLetters($input.val());
		} else {
			return customEmailValidation($input.val()) && checkEmailLength($input);
		}
	}

	function checkUsernameLength($input) {
		return ($input.val().length <= MAX_LENGTH_USERNAME && $input.val().length >= MIN_LENGTH_USERNAME);
	}

	function checkEmailLength($input) {
		return ($input.val().length <= MAX_LENGTH_EMAIL && $input.val().length >= MIN_LENGTH_EMAIL);
	}

	function differFromUsername() {
		var returnValue;
		if (isFirstStepCasinoLobby()) {
			returnValue = FIRST_STEP_USERNAME;
		} else if (isSecondStepCasinoLobby()) {
			returnValue = SECOND_STEP_USERNAME;
		} else if (isFirstStepLandingPage()) {
			returnValue = LANDING_SIGNUP + ' ' + FIRST_STEP_USERNAME;
		} else if (isSecondStepLandingPage()) {
			returnValue = LANDING_SIGNUP + ' ' + SECOND_STEP_USERNAME;
		}
		handlePasswordGreenTick();
		return returnValue;
	}

	function equalToPassword() {
		var returnValue;
		if (isFirstStepCasinoLobby()) {
			returnValue = FIRST_STEP_PASSWORD;
		} else if (isSecondStepCasinoLobby()) {
			returnValue = SECOND_STEP_PASSWORD;
		} else if (isFirstStepLandingPage()) {
			returnValue = LANDING_SIGNUP + ' ' + FIRST_STEP_PASSWORD;
		} else if (isSecondStepLandingPage()) {
			returnValue = LANDING_SIGNUP + ' ' + SECOND_STEP_PASSWORD;
		}
		return returnValue;
	}

	function isFirstStepCasinoLobby() {
		return $signUpDetails.parent().css('display') === 'none' && landingSignUp.length === 0;
	}

	function isSecondStepCasinoLobby() {
		return $signUpDetails.parent().css('display') !== 'none' && landingSignUp.length === 0;
	}

	function isFirstStepLandingPage() {
		return $signUpDetails.parent().css('display') === 'none' && landingSignUp.length > 0;
	}

	function isSecondStepLandingPage() {
		return $signUpDetails.parent().css('display') !== 'none' && landingSignUp.length > 0;
	}

	function setupFormSelectors(signUpAccount) {
		var $boxes = signUpAccount.$box.parent();
		$signUpAccount = $boxes.find('#signup-account');
		$signUpDetails = $boxes.find(SIGNUP_DETAILS_ID);
		landingSignUp = $(LANDING_SIGNUP);
		$year = $boxes.find('select[name=PARAM_YEAR]');
		$month = $boxes.find('select[name=PARAM_MONTH]');
		$day = $boxes.find('select[name=PARAM_DAY]');
		$autoFill = $boxes.find('#signup-autofill');
		$birthDate = $boxes.find('#birth-date-id');
		$gamblingRange = $boxes.find('select[name=gamblingRangeSelect]');
	}

	function setupGender(box) {
		$gender = box.$box.parent().find('#gender-id');
	}

	function onFocusOutAutofill() {
		var autoFillParent = $autoFill.parent();
		autoFillParent.focusout(function () {
			if (!autoFillParent.hasClass('has-error')) {
				toolTip.hidePopover(autoFillParent);
			} else {
				toolTip.showError(autoFillParent);
			}
		});
	}

	function setupValidation(signUpAccountParent) {
		setupFormSelectors(signUpAccountParent);
		setupFormValidation();
		setupFocusPopover(signUpAccountParent);
		setupGender(signUpAccountParent);

		removeGreenTickWhenContentEmpty();
		onFocusOutAutofill();
		onFocusOutDateOfBirth();
	}

	var signUpValidation = {};
	signUpValidation.setupValidation = setupValidation;
	signUpValidation.validateDateTheFirstTime = validateDateTheFirstTime;
	signUpValidation.validateDanishGamblingRange = validateDanishGamblingRange;
	signUpValidation.isFormValidated = isFormValidated;
	signUpValidation.hideGreenTick = hideGreenTick;
	signUpValidation.showGreenTick = showGreenTick;
	signUpValidation.fillCPRFormattedCode = fillCPRFormattedCode;
	signUpValidation.isEmailValid = function ($input) {
		return customEmailValidation($input.val()) && checkEmailLength($input);
	};

// to bind this behavior for the unregistered users who come back to our website
	signUpValidation.updateInputWithGreenTick = updateInputWithGreenTick;

	return signUpValidation;
});


